import type { SiteConfig } from '../../@types/context/site-config.types';

export const contactAxoNoConfig: Pick<SiteConfig, 'contact'> = {
  contact: {
    phone: '22 86 74 00',
    email: 'kundeservice@axofinans.no',
  },
};
